module.exports = __webpack_public_path__ + "img/KM-360A_15.e4d7b701.jpg";